import { render, staticRenderFns } from "./LexinKeyboard.vue?vue&type=template&id=7668525a&"
import script from "./LexinKeyboard.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports